import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ScrollableComicRow from "./components/ScrollableComicRow";
import CategorySection from "./components/CategorySection";
import ComicGrid from "./components/ComicGrid";
import CTASection from "./components/CTASection";
import HomeSEO from "./components/HomeSEO";

export default function Home() {
  return (
    <>
      <HomeSEO />
      <Navbar />
      <main>
        <HeroSection />
        <ScrollableComicRow />
        <CategorySection />
        <ComicGrid />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}